module.exports = __webpack_public_path__ + "static/media/teaCupIcon.05fa5781.svg";